import { cva } from '@/styled-system/css';

export const tabsTabIconRecipe = cva({
  base: {
    color: 'inherit',
    marginInlineEnd: 'tighter',
  },
});
